import { AxiosResponse } from 'axios';
import { SET_EMPLOYEE_PAYROLL_COMPONENTS, SET_EMPLOYEE_PAYROLL_COMPONENT, SET_ERRORMSG } from '@/store/mutation_types';
import {
  CLEAR_EMPLOYEE_PAYROLL_COMPONENT_ISLOADING,
  DELETE_EMPLOYEE_PAYROLL_COMPONENT,
  EDIT_EMPLOYEE_PAYROLL_COMPONENT,
  GET_EMPLOYEE_PAYROLL_COMPONENTS,
  GET_EMPLOYEE_PAYROLL_COMPONENT,
  REGISTER_EMPLOYEE_PAYROLL_COMPONENT,
  TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE,
} from '@/store/action_types';
import { StateObject } from '@/dtos/state.dto';
import EmployeePayrollComponent from '@/services/employee_payroll_component';
import { Module } from 'vuex';
import { EditEmployeePayrollComponent, RegisterEmployeePayrollComponent, GetEmployeePayrollComponent } from '@/dtos/employee_payroll_component.dto';

const employeePayrollComponent: Module<any, {}> = {
  state: {
    employeePayrollComponent: {
      data: null,
      isLoading: false,
    },
    employeePayrollComponents: {
      data: null,
      isLoading: false,
    },
  },
  getters: {
    employeePayrollComponent: (state: { employeePayrollComponent: any }) => state.employeePayrollComponent,
    employeePayrollComponents: (state: { employeePayrollComponents: any }) => state.employeePayrollComponents,
  },
  mutations: {
    [SET_EMPLOYEE_PAYROLL_COMPONENT]: (
      state: { employeePayrollComponent: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeePayrollComponent.data = payload.data) : null,
        (state.employeePayrollComponent.isLoading = payload.isLoading);
    },
    [SET_EMPLOYEE_PAYROLL_COMPONENTS]: (
      state: { employeePayrollComponents: StateObject },
      payload: { data: null; status: any; isLoading: any }
    ) => {
      payload.data != null ? (state.employeePayrollComponents.data = payload.data) : null,
        (state.employeePayrollComponents.isLoading = payload.isLoading);
    },
  },
  actions: {
    [REGISTER_EMPLOYEE_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.registerEmployeePayrollComponent(
        payload as RegisterEmployeePayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_PAYROLL_COMPONENTS]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENTS, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.getEmployeePayrollComponents(
        payload as GetEmployeePayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_PAYROLL_COMPONENTS, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENTS, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENTS, { isLoading: false });
        return false;
      }
    },
    [GET_EMPLOYEE_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.getEmployeePayrollComponents(
        payload as GetEmployeePayrollComponent
      );

      if (result) {
        if (result.data.status) {
          commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: result.data.data[0], isLoading: false });
          return result.data.data[0];
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [EDIT_EMPLOYEE_PAYROLL_COMPONENT]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.editEmployeePayrollComponent(
        payload as EditEmployeePayrollComponent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [TOGGLE_EMPLOYEE_PAYROLL_COMPONENT_IS_ACTIVE]: async ({ commit }: any, payload: any) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.toggleEmployeePayrollComponentIsActive(
        payload as EditEmployeePayrollComponent
      );

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [DELETE_EMPLOYEE_PAYROLL_COMPONENT]: async ({ commit }: any, payload: string) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: true });

      const result: AxiosResponse = await EmployeePayrollComponent.deleteEmployeePayrollComponent(payload);

      if (result) {
        if (result.data.status) {
          console.log('result.data.data', result.data.data);
          commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: result.data.data, isLoading: false });
          return true;
        }
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { data: null, isLoading: false });
        commit(SET_ERRORMSG, result.data.msg);
        return false;
      } else {
        commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
        return false;
      }
    },
    [CLEAR_EMPLOYEE_PAYROLL_COMPONENT_ISLOADING]: ({ commit }) => {
      commit(SET_EMPLOYEE_PAYROLL_COMPONENT, { isLoading: false });
      commit(SET_EMPLOYEE_PAYROLL_COMPONENTS, { isLoading: false });
    },
  },
};

export default employeePayrollComponent;
